import React, {useEffect, useState} from 'react'
import {useSnackbar} from "notistack";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import {useDeleteHotelMutation} from "../../../services/authService";
import ConfirmDialog from "../../ConfirmDialog";
import messages from "../../../utils/messages";
import styles from "../showName/DeleteShowName.module.scss";

const DeleteHotel = ({ hotel, setHotel, onDelete }) => {
    const [deleteHotel, { isSuccess, error, reset }] = useDeleteHotelMutation();
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        deleteHotel(hotel.id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteHotel}`, { variant: 'success' });
            reset();
            onDelete();
            setHotel(null);
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <ConfirmDialog
                title="Delete hotel"
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                {messages.confirm.deleteHotel}
            </ConfirmDialog>
        </>
    )
}

export default DeleteHotel
